import * as React from 'react';
import {show} from 'react-notification-system-redux';

export function success(title: string, message: string, position: string = 'tr', image?: any): any {
    return notification(title, message, 'success', position, image);
}

export function error(title: string, message: string, position: string = 'tr', image?: any): any {
    return notification(title, message, 'error', position, image);
}

export function warning(title: string, message: string, position: string = 'tr', image?: any): any {
    return notification(title, message, 'warning', position, image);
}

function notification(title: string, message: string, level: string = 'success', position: string = 'tr', image?: any): any {
    const opts = {
        position: (position ? `${position}` : 'tr'),
        children: (
            <div className={`notification notification--${level}`}>
                <div className='notification__content-wrap'>
                    {image ? <img className='notification__img' src={image} alt='notification-img'/> : ''}
                    <div className='notification__content'>
                        <h5 className='notification__title bold-text'>{title}</h5>
                        <p className='notification__message'>{message}</p>
                    </div>
                </div>
            </div>
        )
    }

    return show(opts, level);
}


// WEBPACK FOOTER //
// ./src/utils/notification-actions.tsx